
<div class="mc-tabs-switcher">
  <div class="tab-item"  [ngClass]="{'Active':active === 0}" routerLinkActive="active" [routerLink]="['overview']" (click)="overview()">
    <span>{{'label_Overview' | xsI18n}}</span>
  </div>
  <!--<div class="tab-item" ng-class="{'Active':ui.activeIdx===1}" ng-click="ui.onTabClick($event, 1)"><span>{{'label_Applications' | i18n}}</span></div>-->
  <!--<div class="tab-item" ng-class="{'Active':ui.activeIdx===2}" ng-click="ui.onTabClick($event, 2)"><span>{{'label_Configurations' | i18n}}</span></div>-->
  <div class="tab-item" [ngClass]="{'Active':active === 1}" routerLinkActive="active" [routerLink]="['location']" (click)="location()">
    <span>{{'label_Location' | xsI18n }}</span>
  </div>
</div>
